import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.retrieval-request',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.retrieval-request/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.retrieval-request/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.retrieval-request/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.retrieval-request/${id}`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.retrieval-request/${id}/apply`,
    method: 'put',
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.retrieval-request/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.retrieval-request/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number) => {
  return axiosService({
    url: `/api.retrieval-request/${id}/approve`,
    method: 'put',
    data: {},
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.retrieval-request/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.retrieval-request',
    method: 'post',
    data,
  })
}
